import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { useMeta } from "vue-meta";


export default /*#__PURE__*/_defineComponent({
  __name: 'RefundPolicyView',
  setup(__props, { expose }) {
  expose();

useMeta({
  title: "Refund Policy",
});

onMounted(() => document.dispatchEvent(new Event("custom-render-trigger")));

const __returned__ = { onMounted, useMeta }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})